// @flow
import * as React from 'react'
import Input from 'ui/atoms/BlankInput'
import Text from 'ui/atoms/Text'
import SelectableFlatCard from 'ui/molecules/SelectableFlatCard'

type Props = {
  active?: boolean,
  error?: string,
  onBlur?: () => void,
  onChange?: (SyntheticEvent<HTMLInputElement>) => void,
  onFocus?: () => void,
  placeholder?: string,
  value?: string,
}

function PageTitleInput({
  active,
  error,
  onBlur,
  onChange,
  onFocus,
  placeholder,
  value,
}: Props): React.Node {
  return (
    <SelectableFlatCard $noPadding border $active={active} error={error}>
      <Text $medium $xlarge>
        <Input
          onBlur={onBlur}
          onChange={onChange}
          onFocus={onFocus}
          placeholder={placeholder}
          type="text"
          value={value}
        />
      </Text>
    </SelectableFlatCard>
  )
}

export default PageTitleInput
